<template>
  <div class="page-card-content" v-bind:style="{ backgroundImage: 'url(' + previewSrc + ')' }">

    <div class="page-card-gradient -bottom-up"></div>
    <div class="page-card-gradient -top-right-conner"></div>
    <div class="page-card-line"></div>

    <div class="page-card-container">
      <div class="preview-text">
        <h3 class="page--title" v-if="title">{{ title }}</h3>
        <div class="mb-15 text-left" v-if="false">ข้อความเชิญชวน</div>
        <div ref="captureTextVirtualWrapper" style="display: none">
          <div class="page--message captureTextVirtual" ref="captureTextVirtual"></div>
        </div>
        <div class="page--message" ref="captureTextDisplay">
          {{ displayMessage }}
        </div>
        <div>
          <div class="page--province"><span v-if="school">{{ school.name }}</span> <span v-if="province">จังหวัด{{ province.name }}</span></div>
        </div>
        <div v-if="owner" class="mt-15">
          <div class="">เจ้าของกองผ้าป่า</div>
          <div class="page--owner">{{ owner }}</div>
        </div>
      </div> <!-- /preview-text -->
    </div>

    <div class="page-card-image-logo">
      <img src="../assets/domain-custom/base/logo-domain-desktop.png" />
    </div>

  </div>
</template>

<script>
  export default {
    name: 'PageCardContent',

    props: {
      title: {
        type: String,
        default: ''
      },
      message: {
        type: String,
        default: ''
      },
      province: {
        type: Object,
        default: null
      },
      school: {
        type: Object,
        default: null
      },
      owner: {
        type: String,
        default: ''
      },
      previewSrc: {
        type: String,
        default: ''
      }
    },
    data () {
      return {
        virtualDisplayStyle: 'none',
        displayDisplayStyle: 'block'
      }
    },
    computed: {
      displayMessage () {
        let m = this.message || 'กองผ้าป่านี้เพื่อน้องๆ ได้มีโอกาสทางการศึกษา มาช่วยกันนะ'
        return m.trim()
      }
    },
    methods: {
      capture () {
        let display = this.$refs.captureTextDisplay
        let virtual = this.$refs.captureTextVirtual
        let virtualWrapper = this.$refs.captureTextVirtualWrapper

        display.style.display = 'none'
        virtualWrapper.style.display = 'block'

        let currentHeight = 0
        let processing = false
        let currentVirtualInnerHTML = ''

        for (let i = 0; i < this.displayMessage.length; i++) {
          currentVirtualInnerHTML = virtual.innerHTML
          virtual.innerHTML += this.displayMessage[i]
          if (virtual.clientHeight > currentHeight) {
            if (processing) {
              virtual.innerHTML = currentVirtualInnerHTML + '<br/>' + this.displayMessage[i]
            }
            currentHeight = virtual.offsetHeight
            processing = true
          }
        }
      }
    }
  }
</script>

<style lang="scss" scoped>

.page-card-content {
  width: 1200px;
  height: 630px;
  overflow: hidden;
  background-color: #fff !important;
  background: no-repeat center center;
  background-size: cover;
  position: relative;
  word-wrap: normal;

  .page-card-gradient {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
  }
  .page-card-gradient.-bottom-up {
    background: linear-gradient(to bottom, rgba(0,0,0,0) 50%,rgba(0,0,0,0.99) 100%);
  }
  .page-card-gradient.-top-right-conner {
    background: linear-gradient(45deg, rgba(0,0,0,0) 65%,rgba(0,0,0,0.99) 100%);
  }
  .page-card-line {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: url("../assets/img/page-card-line.png") no-repeat bottom center;
  }
  .page-card-image-logo {
    position: absolute;
    top: 26px;
    right: 30px;
    width: 137px;
    height: 88px;
    background: url("../assets/domain-custom/base/logo-domain-desktop@2x.png") no-repeat center center;
    background-size: cover;
  }

  .page-card-container {
    width: 840px;
    height: 100%;
    margin: 0 auto;
    position: relative;
  }
  .preview-text {
    bottom: 5%;
    left: 10%;
    text-align: center;
    position: absolute;
    right: 10%;
    color: #fff;
    text-shadow: 0 2px 4px rgba(0,0,0,0.5);
    .page--message {
      text-align: center;
      color: #fff;
      font-size: 1.4em;
      font-weight: 400;
      line-height: 1.4em;
      &:before, &:after { content: '"' }
    }
    .page--title {
      color: #fff;
      font-size: 2.5em;
      margin-bottom: 20px;
    }
    .page--province {
      font-size: 1.1em;
      margin-bottom: 20px;
      margin-top: 10px;
    }
    .page--owner {
      font-weight: 500;
      font-size: 1.2em;
      margin: 10px 0;
    }
  }
}

/* On screens that are 600px or less, set the background color to olive */
/*
@media screen and (max-width: 767px) {

  .wrapper-preview {
    position: relative;
    overflow: hidden;

    .preview-image {
      padding: 0;
      box-shadow: 0;
      background: #fff;
      border: none;
      display: block;
      position: relative;
      .preview-cover {
        max-height: 300px;

      }
      &:after {
        margin: -3px;
        width: 103%;
      }
    }
    .preview-text {
      bottom: 5%;
      left: 5%;
      right: 5%;

      .page--message {
        text-align: center;
        color: #fff;
        font-size: 1.1em;
        font-weight: 400;
        line-height: 1.3em;
      }
      .page--title {
        display: none;
      }
      .page--province {
        display: none;
      }
      .page--owner {
        display: none;
      }
    }
  }
}
*/

</style>



// WEBPACK FOOTER //
// PageCardContent.vue?7dbb34b9